import ImageClass, { asImages, ImageObject } from "@lss/common/src/shell/Image";
import { parseRequire } from "../../src/utils/parseImageUrl";

export const annProfilesPic = asImages({
    annInstaPortrait1: { url: parseRequire(require('@lss/common/game/assets/images/Instagram/Phone/annInstaPortrait1.webp')) },
    annInstaPortrait2: { url: parseRequire(require('@lss/common/game/assets/images/Instagram/Phone/annInstaPortrait2.webp')) },
    annInstaPortrait3: { url: parseRequire(require('@lss/common/game/assets/images/Instagram/Phone/annInstaPortrait3.webp')) },
    annInstaPortrait4: { url: parseRequire(require('@lss/common/game/assets/images/Instagram/Phone/annInstaPortrait4.webp')) },
});
export const annOtherPics = asImages({
    wallpaper1: { url: parseRequire(require(`@lss/common/game/assets/images/Extras/wallpaper1.webp`)) },
});


export const annImages = asImages({
    Ann1: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann1.webp`)) },
    Ann2: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann2.webp`)) },
    Ann3: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann3.webp`)) },
    Ann4: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann4.webp`)) },
    Ann5: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann5.webp`)) },
    Ann6: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann6.webp`)) },
    Ann7: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann7.webp`)) },
    Ann8: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann8.webp`)) },
    Ann9: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann9.webp`)) },
    Ann10: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann10.webp`)) },
    Ann11: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann11.webp`)) },
    Ann12: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann12.webp`)) },
    Ann13: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann13.webp`)) },
    Ann14: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann14.webp`)) },
    Ann15: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann15.webp`)) },
    Ann16: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann16.webp`)) },
    Ann17: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann17.webp`)) },
    Ann18: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann18.webp`)) },
    Ann19: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann19.webp`)) },
    Ann20: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann20.webp`)) },
    Ann21: {
        url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann21.webp`)),
        partials: {
            Ann21_1: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann21_1.webp`)) },
        }
    },
    Ann22: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann22.webp`)) },

    Ann23: {
        url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann23.webp`)),
        partials: {
            Ann23_1: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann23_1.webp`)) },
            Ann23_2: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann23_2.webp`)) },
            Ann23_3: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann23_3.webp`)) },
            Ann23_4: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann23_4.webp`)) },

        }
    },
    Ann24: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann24.webp`)) },
    Ann25: {
        url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann25.webp`))

    },
    Ann26: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann26.webp`)) },
    Ann27: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann27.webp`)) },
    Ann28: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Ann/Ann28.webp`)) },

});
